import { render, staticRenderFns } from "./dialog-detailpackegehistory.vue?vue&type=template&id=9166b4a0&"
import script from "./dialog-detailpackegehistory.vue?vue&type=script&lang=js&"
export * from "./dialog-detailpackegehistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports